/**
 * Utils function to simplify template parsing.
 */
export function createElementFromTemplate(tmpl) {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = tmpl;
    return Array.from(wrapper.children, (el) => el);
}
